import { DocumentNode, gql } from '@apollo/client'

export const BOOK: DocumentNode = gql`
    mutation Book(
        $date: Date!
        $from: Time!
        $to: Time!
        $child_id: [Int]!
        $comment: String
        $daycare_id: Int!
        $place_id: Int
        $external_icon: OccasionalSlotIcon
    ) {
        book(
            date: $date
            from: $from
            to: $to
            child_id: $child_id
            comment: $comment
            daycare_id: $daycare_id
            place_id: $place_id
            external_icon: $external_icon
        )
    }
`

export const BOOK_MERGER: DocumentNode = gql`
    mutation bookFusion(
        $daycare_id: Int!
        $date: Date!
        $from: Time!
        $to: Time!
        $child_id: [Int]!
        $comment: String
        $place_id: Int
        $external_icon: OccasionalSlotIcon
    ) {
        bookFusion(
            daycare_id: $daycare_id
            date: $date
            from: $from
            to: $to
            child_id: $child_id
            comment: $comment
            place_id: $place_id
            external_icon: $external_icon
        )
    }
`

export const UNBOOK: DocumentNode = gql`
    mutation Unbook(
        $occasional_slot_id: Int
        $date: Date
        $start: Time
        $end: Time
        $child_id: Int!
        $daycare_id: Int!
        $parent_comment: String
    ) {
        unbook(
            occasional_slot_id: $occasional_slot_id
            date: $date
            start: $start
            end: $end
            child_id: $child_id
            daycare_id: $daycare_id
            parent_comment: $parent_comment
        )
    }
`
